import { BillingTemplate } from "@/components/Templates";
import { useBillingPage } from "@/hooks/useBillingPage";

export function BillingPage() {
  const billing = useBillingPage();

  return <BillingTemplate {...billing} />;
}
